import React, { useMemo } from "react";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";

export default function AreaDemandReport() {
  const columns = useMemo(
    () => [
      { name: "Area", selector: (r) => r.Area || r.area || "-" },
      { name: "Enquiries", selector: (r) => r.EnquiryCount ?? r.enquiries ?? 0 },
      { name: "Sold", selector: (r) => r.SoldCount ?? r.sold ?? 0 },
      { name: "Conversion %", selector: (r) => r.ConversionPct ?? r.conversionPct ?? 0 },
    ],
    []
  );

  return (
    <ReportViewer
      reportKey="areaDemand"
      title="Area-wise Demand"
      columns={columns}
      fetchConfig={{
        url: "/reports/app2/area-demand",
        paramsBuilder: (filters) => ({
          fromDate: filters.fromDate,
          toDate: filters.toDate,
        }),
      }}
      buildKpis={(rows) => {
        const enq = (rows || []).reduce((a, r) => a + Number(r?.EnquiryCount ?? r?.enquiries ?? 0), 0);
        const sold = (rows || []).reduce((a, r) => a + Number(r?.SoldCount ?? r?.sold ?? 0), 0);
        const pct = enq > 0 ? ((sold / enq) * 100).toFixed(1) : "0.0";
        return [
          { label: "Enquiries", value: enq },
          { label: "Sold", value: sold },
          { label: "Conversion %", value: pct },
        ];
      }}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

